// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 279 ? "6c44d60f" : chunkId) + "." + {"229":"d48d4ac0c7b45ffd","279":"65dba80146c5eb6d","480":"a401c93ce1ba5f95","678":"dc01ec7a192e6ebd"}[chunkId] + ".js";
};